module.exports = __webpack_public_path__ + "12e7310b.svg";